<form
	#templateForm="ngForm"
	(ngSubmit)="updateInvoiceAppointment()"
	[formGroup]="componentForm">
	@if (componentForm.invalid && templateForm.submitted) {
		<gandalf-lib-validation-messages
			[form]="componentForm"
			[requestObj]="updateInvoiceAppointmentRequest">
		</gandalf-lib-validation-messages>
	}
	<ejs-grid
		autoFitColumns
		class="table-rowlink"
		gridLines="Horizontal"
		[dataSource]="appointmentsList"
		[autoFitBlacklist]="['formattedEmployeeOrProviderOrRole']"
		[allowSorting]="true"
		[allowSelection]="true"
		[allowResizing]="true"
		(rowSelected)="submitForm($event)"
		[pmsGridSubmit]="isSearchingOrSubmitting"
		[pmsGridSubmitDefaultSortOptions]="sortOptions">
		<e-columns>
			<e-column field="startDate" headerText="Date" [format]="appointmentsTableDateFormat"></e-column>
			<e-column field="location" headerText="Location"></e-column>
			<e-column field="type" headerText="Type"></e-column>
			<e-column field="subTypeValue" headerText="Category"></e-column>
			<e-column field="formattedEmployeeOrProviderOrRole" headerText="Provider"></e-column>
		</e-columns>
	</ejs-grid>
</form>
